import React, { ReactNode } from 'react';
import { v4 as uuid } from 'uuid';

import { IconTypes } from '@eika/icon';
import { ErrorLabel } from '@eika/label';

import { StringKeyValue } from '../actions/types';
import { useAppSelector } from '../hooks/redux';
// import { AppState } from '../reducers';
import { ContextReducer } from '../reducers/context';
import { ErrorReducer } from '../reducers/error';
import AppErrors from './AppErrors';

interface Props {
    children: ReactNode;
}

const App: React.FC<Props> = ({ children }) => {
    const appErrorMessages = (appErrors: ContextReducer['appErrors']) => {
        const isDevelop = process.env.NODE_ENV !== 'production';
        const errors = appErrors.map((appError) => (
            <p key={uuid()}>
                <ErrorLabel icon={IconTypes.UTROPSTEGN_24} text={appError} />
            </p>
        ));
        return isDevelop && appErrors.length ? (
            <div className="missing-keys">
                <div style={{ maxWidth: '500px', margin: '0 auto' }}>{errors}</div>
            </div>
        ) : (
            <></>
        );
    };

    const text = useAppSelector((s) => s.context.config.data.text as StringKeyValue);
    const context = useAppSelector((s) => s.context as ContextReducer);
    const error = useAppSelector((s) => s.error as ErrorReducer);
    const { appErrors } = context;

    return (
        <>
            {appErrorMessages(appErrors)}
            {error.errorMessage ? (
                <AppErrors text={text} error={error} />
            ) : (
                <>
                    <input type="hidden" className="tracking-input" value={window.location.pathname} />
                    {children}
                </>
            )}
        </>
    );
};

export default App;
